import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import {
  ICancelSubscriptionDto,
  ICreateCheckoutSessionDto,
  ICreatePortalSessionDto,
  IGetAccountSubscriptionInfoResopnseDto,
  IGetAccountTransactionsResopnseDto,
  IGetSubscriptionInvoicesResopnseDto,
  IGiftSubscriptionDto,
  IMessageResponseDto,
  IPaymentMethodsResponseDto,
  IRenewSubscriptionDto,
  IRetrieveSubscriptionPricesRespDto,
  IUpgradeSubscriptionDto,
} from 'src/types'

class PaymentsService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  createCheckoutSession(dto: ICreateCheckoutSessionDto) {
    return this.post<string, ICreateCheckoutSessionDto>('payments/create-checkout-session', dto)
  }

  retrievePaymentMethods(account: string) {
    return this.get<IPaymentMethodsResponseDto>('payments/payment-methods', { params: { account } })
  }

  retrieveSubscriptionInvoices(account: string) {
    return this.get<IGetSubscriptionInvoicesResopnseDto>('payments/subscription-invoices', {
      params: { account },
    })
  }

  retrieveAccountTransactions(account: string) {
    return this.get<IGetAccountTransactionsResopnseDto>('payments/transactions', {
      params: { account },
    })
  }

  retrieveAccountSubscriptionInfo(accountId: string) {
    return this.get<IGetAccountSubscriptionInfoResopnseDto>('payments/subscription/status', {
      params: { accountId },
    })
  }

  createPortalSession(dto: ICreatePortalSessionDto) {
    return this.post<string, ICreatePortalSessionDto>('payments/create-portal-session', dto)
  }

  upgradeSubscription(dto: IUpgradeSubscriptionDto) {
    return this.post<IMessageResponseDto, IUpgradeSubscriptionDto>(
      'payments/upgrade-subscription',
      dto,
    )
  }

  cancelSubscription(dto: ICancelSubscriptionDto) {
    return this.put<IMessageResponseDto, ICancelSubscriptionDto>(
      'payments/subscription-cancel',
      dto,
    )
  }

  retrieveSubscriptionPrices(accountId: string) {
    return this.get<IRetrieveSubscriptionPricesRespDto>(`payments/prices/${accountId}`)
  }

  renewSubscription(dto: IRenewSubscriptionDto) {
    return this.put<IMessageResponseDto, IRenewSubscriptionDto>('payments/subscription-renew', dto)
  }

  giftSubscription(dto: IGiftSubscriptionDto) {
    return this.post<IMessageResponseDto, IGiftSubscriptionDto>('payments/gift-subscription', dto)
  }
}

export const paymentsService = new PaymentsService()

export default PaymentsService
